const generateEnableTicketingFlag = (statusCode, statusName) => {
  return statusCode?.enableTicketing !== undefined
    ? statusCode?.enableTicketing
    : !['PENDING', 'CANCELLED', 'CANCELED', 'HOLD'].some(s => s === (statusName || statusCode?.name));
};

export default generateEnableTicketingFlag;
